module.exports = __webpack_public_path__ + "img/link_cn.7d67a52d.png";